import React from "react";

const IconDone = () => (
  <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M28.2551 7.28604C28.7758 7.80673 28.7758 8.65096 28.2551 9.17165L13.2645 24.1624C12.6917 24.735 11.763 24.735 11.1903 24.1624L3.74208 16.7141C3.22139 16.1934 3.22139 15.3492 3.74208 14.8285C4.26278 14.3078 5.107 14.3078 5.6277 14.8285L12.2274 21.4281L26.3695 7.28604C26.8902 6.76533 27.7345 6.76533 28.2551 7.28604Z"
      fill="white"
      fillOpacity="0.9"
    />
  </svg>
);

export default IconDone;
